export const EXPIRED_MONITORING_STATUSES = ['MON_EMP', 'MON_EXIT', 'MON_UNEMP']; // not in use for new cases but keep the old cases work
export const OPEN_CASE_STATUS_CODES = ['INPR', 'ACT', 'MON'].concat(EXPIRED_MONITORING_STATUSES);
